var ProductsCarousel = {
	setArrowsPosition: function( $container, $arrows ){
		var $cardImage = $container.find( '.product-card-image' );
		var topIndent  = $cardImage.height() / 2;
		$arrows.prev.css( 'top', topIndent );
		$arrows.next.css( 'top', topIndent );
	},
	init: function(){
		var self = this;
		$( '.products-slider-swiper' ).each(
			function(){
				var $container = $( this );
				var $arrows    = {
					'prev': $container.closest( '.section-products' ).find( '.swiper-button-prev' ),
					'next': $container.closest( '.section-products' ).find( '.swiper-button-next' )
				};
				var swiper     = new Swiper(
					$container.get( 0 ),
					{
						slidesPerView: 1,
						spaceBetween: 24,
						autoHeight: true,
						watchOverflow: true,
						loop: true,
						preventClicks: false,
						navigation: {
							nextEl: $arrows.next.get( 0 ),
							prevEl: $arrows.prev.get( 0 ),
						},
						breakpoints: {
							767: {
								slidesPerView: 2,
							},
							980: {
								slidesPerView: 3,
							}
						}
					},
				);
				self.setArrowsPosition( $container, $arrows );

				$( window ).on(
					'resize',
					function(){
						self.setArrowsPosition( $container, $arrows );
					}
				);
			}
		);
	}
}



jQuery(
	function() {
		'use strict';
		ProductsCarousel.init();
	}
);
